import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        dark: true,
        themes: {
            dark: {
                primary: '#283593',
                secondary: '#0097A7',
                tertiary: '#4682bf',
                accent: '#337AB7',
                // background: '#282828',
                // background: '#181818',
            }
        },
    }
});